<template>
  <TirPmInput
    class="datepicker-input"
    ref="$input"
    :model-value="innerValue"
    :label="settings.label"
    :mask="maskOptions"
    :is-disabled="isDisabled"
    :placeholder="placeholder"
    :is-small-size="settings.isSmall"
    :is-show-hint="settings.isShowHint"
    :is-with-hint="settings.isWithHint"
    :is-with-error="isErrorBorder || settings.isWithError"
    :is-with-success="settings.isWithSuccess"
    @complete-mask="onComplete"
    @accept-mask="onAccept"
    @blur="onBlurInput"
    @focus="emit('focus')"
    @enter="emit('enter', isValidInnerValue)"
  >
    <template #rightInputAddons>
      <slot />
    </template>
    <template #hintMessage>
      <slot name="hintMessage" />
    </template>
  </TirPmInput>
</template>

<script lang="ts" setup>
import { computed, PropType, ref } from "vue";
import { TirPmInput } from "tir-pm-input";
import { DatepickerTypeEnum } from "../../enums";
import { useDatepickerInput } from "../../composables";
import { DatepickerInputProps } from "../../types";

const emit = defineEmits<{
  /**Событие обновления даты */
  (e: "update:modelValue", value: Date | undefined): void;
  /**Событие фокуса на инпуте */
  (e: "focus"): void;
  /**Событие enter */
  (e: "enter", isCorrectDate: boolean): void;
  /**Событие блюра */
  (e: "blur", isCorrectDate: boolean): void;
}>();

const props = defineProps({
  /**Выбранная дата */
  modelValue: { type: Date },
  /**Тип инпута (для выбора конфига маски) */
  type: { type: String as PropType<DatepickerTypeEnum>, required: true },
  /**Блокировка */
  isDisabled: { type: Boolean, default: false },
  /**Настройки */
  settings: { type: Object as PropType<DatepickerInputProps>, required: true },
});

/**Ссылка на инпут */
const $input = ref<InstanceType<typeof TirPmInput>>();

/**Дата */
const date = computed(() => props.modelValue);
/**Установить дату */
const setDate = (date: Date | undefined) => emit("update:modelValue", date);

const {
  maskOptions,
  innerValue,
  placeholder,
  isErrorBorder,
  isValidInnerValue,
  onAccept,
  onComplete,
  onBlur,
} = useDatepickerInput({
  date,
  setDate,
  type: props.type,
});

const onBlurInput = () => {
  onBlur();
  emit("blur", isValidInnerValue.value);
};

defineExpose({
  $input,
});
</script>

<style lang="scss" scoped>
.datepicker-input {
  width: 100%;
}
</style>
